import { ApolloProvider } from '@apollo/client';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import '@monolith/css/bootstrap/bootstrap.css';
import '@monolith/css/fonts.css';
import '@monolith/css/font-awesome-6/fontawesome.css';
import './staffImportModalStyles.css';
import '@monolith/css/font-awesome-6/regular.css';
import '@monolith/css/font-awesome-6/light.css';
import '@monolith/css/font-awesome-6/solid.css';
import '@monolith/css/font-awesome-6/brands.css';
import '@monolith/css/font-awesome-6/v4-shims.css';

import App from './App';
import { apolloClient } from './apollo-client';

const root = document.getElementById('root');
ReactDOM.render(
    <ApolloProvider client={apolloClient}>
        <BrowserRouter basename={__APP_MOUNT_PATH__}>
            <App />
        </BrowserRouter>
    </ApolloProvider>,
    root,
);
